const promotionTypes = [{},
  {
    type: 1,
    text: "打折"
  },
  {
    type: 2,
    text: "满赠"
  },
  {
    type: 3,
    text: "组合"
  },
  {
    type: 4,
    text: "满减"
  },
  {
    type: 5,
    text: "套餐"
  },
];
//订单状态标识，常量值
const _OrderStatus = {
  '1': '待审核',
  '2': '进行中',
  '3': '已完成',
  '4': '已中止',
  '5': '已作废'
};
//付款状态标识，常量值
const _PaymentStatus = {
  '0': '未付款',
  '1': '待确认',
  '2': '部分付款',
  '3': '已付款'
};

//收货状态标识，常量值
const _ShippingStatus = {
  '1': '待发货',
  '2': '部分发货',
  '3': '全部发货',
};

//退货方式标识，常量值
const _ReturnProductsType = {
  '1': '上门退货',
  '2': '邮寄退货',
};

//退货单状态标识，常量值
const _ReturnProductsStatus = {
  '1': '待审核',
  '2': '待发货',
  '3': '待收货',
  '4': '已完成',
  //  '5': '已中止',
  '6': '已作废'
};

//收款单状态标识，常量值
const _ReceiptStatus = {
  '0': '待商家收款',
  '1': '商家已收款',
  '2': '已作废',
  '3': '支付失败',
}

//采购返点状态标识
const _SalesRebateStatus = {
  '0': '待确认',
  '1': '待审核',
  '2': '已审核',
}

//预付款提现状态标识
const _AdvanceWithdrawStatus = {
  '0': '待支付',
  '1': '已支付'
}
const methods = {
  /**
   * @DateTime 2019-03-22T15:10:54+0800
   * @param    {[type]}  name       参数名
   * @param    {[type]}  y          滚动条滚动的位置
   * 替换当前history
   */
  replaceState(name, y) {
    let hash = location.hash
    if (!name) {
      return
    }
    if (hash.indexOf(name) > 0) {
      hash = this.delHashParameter(hash, name)
    }
    if (!!y || y === 0) {
      hash = hash + '&' + name + '=' + y
    }
    history.replaceState('', document.title, hash)
  },
  /*删除hash值内的某个参数*/
  delHashParameter(hash, name){
    let baseHash = hash.split("?")[0] + "?"
    let query = hash.split("?")[1]
    if (query.indexOf(name) > -1) {
      let obj = {}
      let arr = query.split("&")
      for (let i = 0; i < arr.length; i++) {
        arr[i] = arr[i].split("=")
        obj[arr[i][0]] = arr[i][1]
      };
      delete obj[name]
      let newHash = baseHash + JSON.stringify(obj).replace(/[\"\{\}]/g,"").replace(/\:/g,"=").replace(/\,/g,"&")
      return newHash
    } else {
      return hash
    }
  },
   /*删除url内的某个参数*/
  delUrlParameter(name){
    let loca = window.location;
    let baseUrl = loca.origin + loca.pathname + "?";
    let query = loca.search.substr(1) || window.location.hash.split("?")[1]; //?前有#，location.search的返回值为''
    if (query.indexOf(name)>-1) {
      let obj = {}
      let arr = query.split("&");
      for (let i = 0; i < arr.length; i++) {
          arr[i] = arr[i].split("=");
          obj[arr[i][0]] = arr[i][1];
      };
      delete obj[name];
      let url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g,"").replace(/\:/g,"=").replace(/\,/g,"&");
      return url
    };
  },
  /**
   * 获取预付款提现状态
   * @param string text
   */
  getAdvanceWithdrawStatusNum(text) {
    if (!text) return
    let status = ''
    for (let key in _AdvanceWithdrawStatus) {
      if (_AdvanceWithdrawStatus[key] == text) {
        status = key
      }
    }
    return status;
  },
  /**
   * 获取采购返点状态
   * @param string text
   */
  getSalesRebateStatusNum(text) {
    if (!text) return
    let status = ''
    for (let key in _SalesRebateStatus) {
      if (_SalesRebateStatus[key] == text) {
        status = key
      }
    }
    return status;
  },
  /**
   * 获取收款单状态
   * @param string text
   */
  getReceiptStatusNum(text) {
    if (!text) return
    let status = ''
    for (let key in _ReceiptStatus) {
      if (_ReceiptStatus[key] == text) {
        status = key
      }
    }
    return status;
  },
  /**
   * 获取订单状态
   * @param string text
   */
  getOrderStatusNum(text) {
    if (!text) return
    let status = ''
    for (let key in _OrderStatus) {
      if (_OrderStatus[key] == text) {
        status = key
      }
    }
    return status;
  },
  /**
   * 获取订单待付款状态
   * @param string text
   */
  getOrderPaymentStatusNum(text) {
    if (!text) return
    let status = ''
    for (let key in _PaymentStatus) {
      if (_PaymentStatus[key] == text) {
        status = key
      }
    }
    return status;
  },
  /**
   * 获取订单发货状态
   * @param string text
   */
  getOrderShippingStatusNum(text) {
    if (!text) return
    let status = ''
    for (let key in _ShippingStatus) {
      if (_ShippingStatus[key] == text) {
        status = key
      }
    }
    return status;
  },
  /**
   * 获取退货单状态
   * @param string text
   */
  getReturnStatusNum(text) {
    if (!text) return
    let status = ''
    for (let key in _ReturnProductsStatus) {
      if (_ReturnProductsStatus[key] == text) {
        status = key
      }
    }
    return status;
  },
  /**
   * 获取浏览器类型
   * @returns {*}
   */
  getBrowserType() {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    if (userAgent.match(/iPhone|iPod/i) != null) {
      //iphone代码
      return "iPhone";
    } else if (userAgent.match(/Android/i) != null) {
      //android代码
      return "Android";
    } else if (userAgent.match(/iPad/i) != null) {
      //ipad代码
      return "iPad";
    }
    var isOpera = userAgent.indexOf("Opera") > -1;
    if (isOpera) {
      return "Opera"
    }; //判断是否Opera浏览器
    if (userAgent.indexOf("Firefox") > -1) {
      return "FF";
    } //判断是否Firefox浏览器
    if (userAgent.indexOf("Chrome") > -1) {
      return "Chrome";
    }
    if (userAgent.indexOf("Safari") > -1) {
      return "Safari";
    } //判断是否Safari浏览器
    if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
      return "IE";
    }; //判断是否IE浏览器
  },
  /**
   * @author 刘小丰
   * @param testObj 验证对象JSON字符串
   * {
   * "name":"名称",//提示名字
   * "isNotEmpty":true, //是否不能为空
   *  "maxLength":2 //最大长度2
   *  "minLength":2 //最小长度2
   * "testStr":/^\S{6,12}$/,//需要满足的正则表达式
   * "testMsg":"0-100,最多的两位小数",//不满足的提示
   * "min":10,//最小值。当值为数字时，才生效
   * "max":5000,//最大值。当值为数字时，才生效
   * "least":100,//最少值。当值为数字时，才生效（比如：大于100）
   * "trim":true,//去除前后空格后再验证
   *  "isNumberFormat_fromSeting_qty":true,//是否建议小数位是否符合系统设置的数量小数位
   *  "sNumberFormat_fromSeting_price":true,//是否建议小数位是否符合系统设置的单价小数位
   * }
   * @param event 校验的控件监听的事件源,或者校验的控件
   */
  testValue: function(value, ele, test) { //验证值是否符合规则
    if (!this.compositionsing) {
      var success = true;
      var nodeDom = ele // input元素
      var testObj = test //验证相关数据，对应页面data-test属性
      var msg = "";
      if (testObj != null) {
        if (typeof testObj === "string") {
          testObj = JSON.parse(testObj);
        }
        /*校验*/
        if (testObj.isNotEmpty && (value == null || value.length == 0)) {
          msg = (testObj.name != null ? testObj.name : "") + "不能为空";
          success = false;
        }
        if (value != null && value != "") { //有值输入才校验
          if (testObj.trim) {
            value = value.replace(/(^\s*)|(\s*$)/g, "");
          }
          if (testObj.maxLength != null && value.length > testObj.maxLength) {
            msg = (testObj.name != null ? testObj.name : "") + "不能超过" + testObj.maxLength + "个字";
            success = false;
          } else if (testObj.minLength != null && value.length < testObj.minLength) {
            msg = (testObj.name != null ? testObj.name : "") + "不能少于" + testObj.minLength + "个字";
            success = false;
          } else if (testObj.testStr != null) {
            var reg = eval(testObj.testStr);
            if (!reg.test(value)) {
              msg = "请输入正确格式的" + (testObj.name != null ? testObj.name : "") + (testObj.testMsg != null ? "(" + testObj.testMsg + ")" : "");
              success = false;
            }

          }
          if (success) {
            if (testObj.isNumberFormat_fromSeting_qty) { //如果限制数量小数位
              if (typeof qtyDigit !== "undefined") { //没有加载digitSettings.js文件的页面即使调用本方法 也不使用设置的小数点位数
                var reg = eval("/(^[\\d]+(\\.[\\d]{0," + qtyDigit + "})?$)|(^[\\d]*$)/");
                // var reg = eval(/(^[\d]+(\.[\d]{0,3})?$)|(^[\d]*$)/);
                if (!reg.test(value)) {
                  msg = "请输入正确格式的" + (testObj.name != null ? testObj.name : "") + "(最多包含" + qtyDigit + "位小数)";
                  success = false;
                }
              }
            }
            if (testObj.sNumberFormat_fromSeting_price) { //如果限制数量小数位
              if (typeof priceDigit !== "undefined") { //没有加载digitSettings.js文件的页面即使调用本方法 也不使用设置的小数点位数
                var reg = eval("/(^[\\d]+(\\.[\\d]{0," + priceDigit + "})?$)|(^[\\d]*$)/");
                // var reg = eval(/(^[\d]+(\.[\d]{0,3})?$)|(^[\d]*$)/);
                if (!reg.test(value)) {
                  msg = "请输入正确格式的" + (testObj.name != null ? testObj.name : "") + "(最多包含" + priceDigit + "位小数)";
                  success = false;
                }
              }
            }
            /*数字相关校验*/
            if ((testObj.min !== null && testObj.min !== undefined) || (testObj.max !== null && testObj.max !== undefined) || (testObj.least !== null && testObj.least !== undefined)) {
              if (isNaN(value)) {
                msg = (testObj.name != null ? testObj.name : "") + "请输入数字";
                success = false;
              } else {
                if ((testObj.min !== null && testObj.min !== undefined) && value < testObj.min) {
                  msg = (testObj.name != null ? testObj.name : "") + "不能小于" + testObj.min;
                  success = false;
                } else if ((testObj.max !== null && testObj.max !== undefined) && value > testObj.max) {
                  msg = (testObj.name != null ? testObj.name : "") + "不能大于" + testObj.max;
                  success = false;
                } else if ((testObj.least !== null && testObj.least !== undefined) && value <= testObj.least) {
                  msg = (testObj.name != null ? testObj.name : "") + "必须大于" + testObj.least;
                  success = false;
                }
              }
            }
          }
        }
        if (testObj.msg != null) {
          msg = testObj.msg;
        }
      }
      if (!success) {
        this.toast(msg)
        this.shine(nodeDom);
      }
      return success;
    }
  },
  /**
   * 闪亮提醒
   * @param element
   * @param options
   */
  shine(element, options) {
    var settings = _.extend({}, {
      start: "#fff",
      color: "#fbb",
      step: 5,
      times: 2,
      length: 4,
      speed: 30
    }, options);
    var arrStart = settings.start.split("");
    var arrColor = settings.color.split("");
    var arrFinish = [];
    var i;

    for (i = 0; i < settings.step; ++i) {
      var newColor = arrStart[0];
      for (var j = 1; j < settings.length; ++j) {
        var l = parseInt(arrStart[j], 16);
        var m = parseInt(arrColor[j], 16);
        newColor += Math.floor(parseInt(l + (m - l) * i / settings.step, 10)).toString(16);
      }
      arrFinish.push(newColor);
    }

    for (i = 0; i < settings.times; ++i) {
      arrFinish = arrFinish.slice(0, arrFinish.length - 1).concat(arrFinish.concat([]).reverse());
    }

    var timer = setInterval(function() {
      if (!arrFinish.length) {
        clearInterval(timer);
        timer = 0;
      } else {
        element.style.backgroundColor = arrFinish.pop();
      }
    }, settings.speed);
  },
  /**
   * 获取当前时间
   * @returns {日期yyyy-MM-dd hh:mm:ss}
   * @param {Object} withHMS:是否返回时分秒
   */
  getNowFormatDate(withHMS) {
    var date = new Date();
    var seperator1 = "-";
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    var result = date.getFullYear() + seperator1 + month + seperator1 + strDate;
    if (withHMS) {
      var seperator2 = ":";
      result += " " + (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + seperator2 +
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + seperator2 +
        (date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds());
    }
    return result;
  },
  /**
   *
   * @returns {日期yyyy-MM-dd}
   */
  getStrDateFormatStrDate(_date, hideYear, showS) {
    var strDate = "";
    try {
      var strDate2 = _date.replace(/-/g, "/");
      var date = new Date(strDate2); //new Date(_date);
      if (date != null && date != undefined && typeof(date) != "undefined") {
        var seperator1 = "-";
        var month = date.getMonth() + 1;
        var strD = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strD >= 0 && strD <= 9) {
          strD = "0" + strD;
        }
        if (hideYear) {
          strDate = month + seperator1 + strD;
        } else {
          strDate = date.getFullYear() + seperator1 + month + seperator1 + strD;
        }
        if (showS) {
          strDate += " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds()
        }
      } else {
        if (hideYear && showS) {
          strDate = _date.substr(4, (_date.length - 5));
        } else if (hideYear && !showS) {
          strDate = _date.substr(4, 5);
        } else if (!hideYear && showS) {
          strDate = _date;
        } else {
          strDate = _date.substr(0, 10);
        }
      }

    } catch (e) {

    }
    return strDate;
  },
  /*处理text*/
  getText(str, def) {
    if (str == null || str == "NaN" || str == "undefined" || str == "") {
      if (def != null) {
        str = def;
      } else {
        str = "";
      }
    }
    return str;
  },
  /*去除所有空格标志*/
  trim(str, is_global) {
    var result;
    if (str != null) {
      if (typeof str == "string") {
        if (is_global != null && is_global.toLowerCase() == "g") {
          result = str.replace(_str_blank1, "");
        } else {
          result = str.replace(_str_blank2, "");
        }
      } else {
        result = str;
      }
    } else {
      result = "";
    }
    return result;
  },
 /**
  * 将指定位置的字符串替换为指定的字符串
  * @param   allstr    原始字符串
  * @param   start     开始的位置
  * @param   end       结束的位置
  * @param   changeStr 用来替换的字符串
  * @param  isLengthChange    是否保持原长度 true 改变 不改变只适用changeStr为单个字符
  * @return  newStr    替换后代字符串
  */
  replaceStr(allstr, changeStr, start, end, isLengthChange) {
    allstr = allstr.toString()
    if (start !== 0 && !start) {
      if (allstr.length < 4) {
        start = 0
      } else {
        start = 5
      }
    }
    if (!end) {
      if (allstr.length < 4 ) {
        end = allstr.length
      } else {
        end = allstr.length - 4
      }
    }
    if (changeStr != 0 && !changeStr) {
      changeStr = '*'
    }
    let length = end - start + 1
    let returnChangeStr = changeStr
    if (allstr.length > 0) {
      if (!isLengthChange && changeStr.length == 1) {
        for (let i = 0; i < length - 1; i++) {
          returnChangeStr += changeStr
        }
      }
      return allstr.substring(0, start - 1) + returnChangeStr + allstr.substring(end, allstr.length); 
    } else {
      console.log('参数错误')
      return allstr
    }
  },
  /*删除无效数据*/
  deletePropertyInvalid(obj, value_delete) {
    if (obj != null) {
      for (var key in obj) {
        if (obj[key] === null) {
          delete obj[key];
        }
      }
      if (value_delete !== null && value_delete !== undefined) {
        for (var key in obj) {
          if (obj[key] == value_delete) {
            delete obj[key];
          }
        }
      }
    }
    return obj;
  },
  /*数字格式化*/
  numberFormat(number, decimals, decPoint, thousandsSep) {
    //   example 1: numberFormat(1234.56);
    //   returns 1: '1,235'
    //   example 2: numberFormat(1234.56, 2, ',', ' ');
    //   returns 2: '1 234,56'
    //   example 3: numberFormat(1234.5678, 2, '.', '');
    //   returns 3: '1234.57'
    //   example 4: numberFormat(67, 2, ',', '.');
    //   returns 4: '67,00'
    //   example 5: numberFormat(1000);
    //   returns 5: '1,000'
    //   example 6: numberFormat(67.311, 2);
    //   returns 6: '67.31'
    //   example 7: numberFormat(1000.55, 1);
    //   returns 7: '1,000.6'
    //   example 8: numberFormat(67000, 5, ',', '.');
    //   returns 8: '67.000,00000'
    //   example 9: numberFormat(0.9, 0);
    //   returns 9: '1'
    //  example 10: numberFormat('1.20', 2);
    //  returns 10: '1.20'
    //  example 11: numberFormat('1.20', 4);
    //  returns 11: '1.2000'
    //  example 12: numberFormat('1.2000', 3);
    //  returns 12: '1.200'
    //  example 13: numberFormat('1 000,50', 2, '.', ' ');
    //  returns 13: '100 050.00'
    //  example 14: numberFormat(1e-8, 8, '.', '');
    //  returns 14: '0.00000001'
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep,
      dec = (typeof decPoint === 'undefined') ? '.' : decPoint,
      s = '',
      toFixedFix = function(n, prec) {
        var k = Math.pow(10, prec);
        return '' + (Math.round(n * k) / k).toFixed(prec);
      };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
  },
  /*获取打折类型*/
  getPromotionTypeShowText(promotionType) {
    if (promotionType != null) {
      for (let i = 0; i < promotionTypes.length; i++) {
        if (promotionTypes[i].type == promotionType) {
          return promotionTypes[i].text;
        }
      }
    }
    return "";
  },
  /*给btn加上默认点击样式，需要加上auto-btn-tap-style的class,需要在每个组件的mounted()里调用*/
  initBtnAutoStyle() {
    let btns = document.querySelectorAll(".auto-btn-tap-style")
    let btnsLength = btns.length
    if (btnsLength > 0) {
      for (let i = 0; i < btnsLength; i++) {
        btns[i].addEventListener("click", function() {
          btns[i].classList.add('btn-opacity')
          setTimeout(() => {
            btns[i].classList.remove('btn-opacity')
          }, 200)
        }, false)
      }
    }
  },
  /*预览图片，vux的previewer组件*/
  showImg(index) {
    this.$refs.previewer.show(index)
  },
  /* 加入购物车 */
  addtocart(item, qty) {
    let self = this;
    if (self.getPermissions(true) < 2) { //如果需要判断权限
      return;
    }
    let requestData = {};
    if (item.promotionType == 5) {
      requestData.status = 1;
      requestData.productId = item.id;
    } else {
      requestData.status = 0;
      requestData.productId = item.productid;
    }
    if (qty <= 0) {
      self.toast('商品购买数量需大于0')
      return
    }
    // requestData.qty = qty ? qty : (item.moq ? item.moq : 1)
    requestData.qty = qty
    self.$sendConfigRequest({
      'requestUri': '/shoppingCart/create',
      'requestType': 'post',
      'requestData': requestData,
      'getDataFromAPICallback': function(data, success, message, code) {
        if (!success) {
          if (!!message) {
            if (message.indexOf('超出库存') > -1) {
              self.toast('商品加购件数(含已加购件数)已超出库存')
            } else {
              self.toast(message)
            }
            return
          }
        }
        self.getShoppingCartQty();
      },
      'manageCode': true,
      'showMessageType': 2,
      'requestFailCallback': function(error) {}
    })
  },
  /*查询购物车数量*/
  getShoppingCartQty() {
    var self = this;
    self.$sendConfigRequest({
      'requestUri': '/shoppingCart/count',
      'requestType': 'get',
      'requestShowLoading': false,
      'showMessageType': 3,
      'getDataFromAPICallback': function(data, success, message, code) {
        if (success) {
          app_userManage.setUserProperty_toLocalStorage(_ShoppingCartNum, data);
          self.$store.commit('setShoppingCartQty', data)
        } else {
          if (!!message) {
            self.toast(message)
          }
        }
        return false;
      },
      'manageCode': true, //处理code
      'requestFailCallback': function(error) {},
    });
  },
  /*点击header的返回按钮*/
  backtrack(refresh, page) { //refresh返回是否刷新上级页面
    if (window.history.length == 1) {
      this.openNewRouter('/index')
    } else {
      if (refresh) {
        if (page) {
          window.history.go(page)
        } else {
          window.history.go(-1)
        }
      } else {
        window.history.back()
      }
    }
  },
  /*打开一个新的路由*/
  openNewRouter(url, verificationPermissions, isNoPush) { //isNoPush:true不加入历史路由；verificationPermissions:true判断权限;isRelogin: true 重新登录
    let routerUrl = ''; //需要跳转的路由
    let cid = this.$store.state.cid
    let time = new Date().getTime();
    if (verificationPermissions && this.getPermissions(true) < 2) { //如果需要判断权限
      return;
    }
    if (!!url && url.indexOf("?") > -1) {
      routerUrl = `${url}&cid=${cid}&time=${time}`
      // pureUrl = url.substr(0, url.indexOf('?'))
    } else if (!!url && url.indexOf("?") == -1) {
      routerUrl = `${url}?cid=${cid}&time=${time}`
      // pureUrl = url
    } else {
      console.log('缺少地址')
      return
    }
    let fullPath = this.$route.fullPath //发起跳转的页面
    let pathJudgment = fullPath.indexOf('/searchpage') == -1 && fullPath.indexOf('/login') == -1 && fullPath.indexOf('/register') == -1 && fullPath.indexOf('/wxauthsucceed') == -1  && fullPath.indexOf('/orderpaymentwx') == -1
    if (pathJudgment) {
      if (isNoPush) {
        this.$router.replace(routerUrl)
      } else {
        this.$router.push(routerUrl)
      }
    } else {
      this.$router.replace(routerUrl)
    }
  },
  /*重新登录*/
  relogin(isNoPush) {
    window.sessionStorageUtil.clear();
    var users_history = window.localStorageUtil.getItem(_USERS_HISTORY);
    window.localStorageUtil.clear();
    window.localStorageUtil.setItem(_USERS_HISTORY, users_history);
    this.openNewRouter('/login', '', isNoPush)
  },
  /**
   * 获取权限（0=未登录(游客)，1=未审核、2=正常用户）
   * 常用提示：游客没有此操作权限，是否立即注册
   * 账户必须审核通过后才有此权限
   * 在用户注册后并审核通过后才拥有全部权限
   */
  getPermissions(autoDispose) {
    var userInfo = app_userManage.getUserInfo_fromLocalStorage();
    if (userInfo == null || userInfo[_SESSION_KEY] == null) {
      if (autoDispose) {
        this.relogin()
      }
      return 0
    } else if (userInfo.newRegister) {
      if (autoDispose) {
        this.alert("账户必须审核通过后才有此权限!")
      }
      return 1
    } else {
      return 2
    }
  },
  /*初始化类别树形菜单*/
  initData(data_src) {
    var data_new = [];
    for (var i = 0; i < data_src.length; i++) {
      data_src[i].grade = 1;
      data_src[i].data = JSON.stringify({
        id: data_src[i].id,
        name: data_src[i].name
      });
      this.insertData(data_src[i], data_new);
    }
    /*把默认分类换到最后的位置显示*/
    if (data_new.length > 0) {
      for (var i = 0; i < data_new.length; i++) {
        if (data_new[i].default) {
          var item_isDefaultef = data_new[i];
          data_new.splice(i, 1);
          data_new.push(item_isDefaultef);
        }
      }
    }
    return data_new;
  },
  /*初始化类别树形菜单*/
  insertData(item, data_new) {
    //item.grade++;
    for (var i = 0; i < data_new.length; i++) {
      if (item.pId == data_new[i].id) {
        item.childItem = [];
        item.grade++;
        for (var j = 0; j < data_new.length; j++) { //防止子类已经加载在data_new中
          if (item.id == data_new[j].pId) {
            var temporary = data_new[j];
            data_new.splice(j, 1);
            temporary.grade = item.grade + 1;
            item.childItem.push(temporary);
            break;
          }
        }
        data_new[i].childItem.push(item);
        return true;
      } else if (data_new[i].childItem.length > 0 && item.grade < 4) { //最多三级
        item.grade++;
        if (this.insertData(item, data_new[i].childItem)) {
          return true;
        } else {
          item.grade--;
        }
      }
    }
    if (item.grade == 1) {
      item.childItem = [];
      data_new.push(item);
    }
  },
  /*toast*/
  toast(content, width, hide, position) { //hide toast消失的回调
    let toastWidth;
    if (!width) {
      toastWidth = content.length > 20 ? '21.6em' : content.length + 1.6 + 'em'
    } else {
      toastWidth = width
    }
    this.$vux.toast.show({
      text: content,
      width: toastWidth,
      isShowMask: true,
      onHide: hide,
      position: position ? position : 'middle'
    })
  },
  /*alert*/
  alert(content, title, hide) { //hide 关闭alert的回调
    this.$vux.alert.show({
      content: content,
      title: title ? title : '提示',
      onHide: hide
    })
  }
}

export {
  methods
}



// WEBPACK FOOTER //
// ./static/utils/methods.js